let id = 0

export default function genericSubtask(task_type: string, customProperties: Record<string, unknown> = {}) {
  id += 1 // Incremental ID for each subtask created

  return {
    id,
    master_task_id: 123123,
    patient_id: 701417,
    program_uuid: 'a54a53ef-4fe3-46ee-aafc-40d83d080149',
    task_type, // <-- task type inserted here
    task_uuid: '5a6d01a0-d50e-4033-87d7-24599c121f55',
    status: 'pending',
    suggested_actions_tracking: [],
    session_counter: 0,
    created_at: '2025-08-27T18:48:16.000000Z',
    updated_at: '2025-08-27T18:48:16.000000Z',
    deleted_at: null,
    last_checked_at: null,
    available_after: null,
    score: 0.14,
    pending_actions: [],
    newsfeed: [],
    data: {},
    payload_version: 2,
    ...customProperties, // <-- custom properties can override any of the above
  }
}
